import React from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import dynamic from 'next/dynamic';

import { ErrorBoundary } from '@bonnet/next/error-boundary';

import { PageSection } from 'reaxl';
import { useFeatures } from 'reaxl-features';

import { vdpResultsDuck } from '@/ducks/vdp';

import LazyComponent from '@/components/LazyComponent';
import OwnerDetails from '@/components/vehicledetails/OwnerDetails';

import DealerDiffContainer from './DealerDiffContainer';

const SimilarInventoryContainer = dynamic(() => import('./SimilarInventoryContainer'), {
    ssr: true,
    loading: () => (
        <div
            id="placeholder-similar-inv"
            style={{ height: 370 }}
        />
    ),
});

export function OwnerDetailsContainer({
    onEmailCTAClick,
    chatClickHandler,
    phoneClickHandler,
    textClickHandler,
}) {
    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory) || {};

    const {
        similar_inventory: [isSimilarInventoryEnabled],
    } = useFeatures(['similar_inventory']);

    // Dealer config hides some UI components based on dealer preference
    if (listing?.dealerConfig?.hideOwnerDetails) return null;

    return (
        <PageSection
            alignment="left"
            className="col-lg-8"
            data-qaid="ownerDetails"
        >
            <ErrorBoundary>
                <OwnerDetails
                    onEmailCTAClick={onEmailCTAClick}
                    chatClickHandler={chatClickHandler}
                    phoneClickHandler={phoneClickHandler}
                    textClickHandler={textClickHandler}
                />
            </ErrorBoundary>
            {isSimilarInventoryEnabled && (
                <LazyComponent
                    key="owner_similar_inventory"
                    fallback={(
                        <div
                            id="placeholder-similar-inv"
                            style={{ height: 370 }}
                        />
                    )}
                >
                    <SimilarInventoryContainer />
                </LazyComponent>
            )}
            <DealerDiffContainer />
        </PageSection>
    );
}

OwnerDetailsContainer.propTypes = {
    /**
     * The callback function fires when email CTA is clicked
     */
    onEmailCTAClick: PropTypes.func,
    /**
     * The callback function fires when chat CTA is clicked
     */
    chatClickHandler: PropTypes.func,
    /**
     * The callback function fires when owner phone is called
     */
    phoneClickHandler: PropTypes.func,
    /**
     * The callback function fires when text CTA is clicked
     */
    textClickHandler: PropTypes.func,
};

export default OwnerDetailsContainer;
